import { useMediaQuery } from "./use-media-query.ts";

export const MOBILE_VIEWPORT_QUERY = "(max-width: 767px)";

export function useIsMobileViewport() {
    return useMediaQuery(MOBILE_VIEWPORT_QUERY);
}
